import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GETCOMPANYSTAT_REQ } from "../../../actions";


function Insights() {
  const dispatch = useDispatch();
  const insights = useSelector((state) => state.company.insights);
  const companyDetails = useSelector((state)=>state.company.details)
  useEffect(() => {
    dispatch(GETCOMPANYSTAT_REQ(companyDetails));
  }, [companyDetails]);

  return (
    <div class="h-full mt-3">
      <div class="relative h-full w-full overflow-hidden bg-white rounded-lg shadow px-4">
        <div class="h-full p-2">
          <div class="h-full flow-root">
            <div class="h-full -mx-4 -my-2 sm:-mx-6 lg:-mx-8 px-1.5">
              {/* iuwjfiw */}
              <iframe
                id="dynamicIframe"
                title="Meta-base"
                className="h-[75vh] w-full"
                src={insights?.iframe_url}
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Insights;
